import React from 'react'
import {Link} from 'gatsby'

const sanitizePattern = new RegExp('^.*//[^/]+', '')

const SearchItemTitle = ({postItem, postItemMini}) => {
	// Vérification de sécurité pour éviter les erreurs
	if (!postItem || !postItem._source || !postItem._source.permalink || !postItem._source.post_title) {
		return null
	}

	const { permalink, post_title } = postItem._source
	const displayTitle = (postItem.highlight && postItem.highlight.post_title)
    ? postItem.highlight.post_title[0] // Si c'est un tableau, prends le premier élément
    : post_title;

	// Vérification supplémentaire pour le titre
	if (!displayTitle || (typeof displayTitle === 'string' && displayTitle.trim() === '')) {
		return null;
	}

	// Titre sans HTML pour aria-label
	const plainTitle = (typeof displayTitle === 'string' ? displayTitle : post_title || '').replace(/<[^>]*>/g, '').trim() || 'Résultat de recherche';
	
	return (
		<h2 className={`search-list-item-title ${postItemMini ? 'search-list-mini-item-title' : ''}`}>
			{permalink.indexOf('roubaixxl') >= 0 ?
				<a
					target="_blank"
					rel="noopener noreferrer"
					href={permalink}
					aria-label={`${plainTitle} (s'ouvre dans un nouvel onglet)`}
					dangerouslySetInnerHTML={{__html: displayTitle}}>
				</a> :
				<Link
					to={permalink.replace(sanitizePattern, '').replace('/roubaix/events/','/agenda/').replace('/roubaix/event/','/agenda/')}
					dangerouslySetInnerHTML={{__html: displayTitle}}>
				</Link>
			}
		</h2>
	)
}

export default SearchItemTitle
